import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  isActive: boolean;
  currentStock?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  current, 
  total, 
  isActive,
  currentStock 
}) => {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
  
  if (!isActive) {
    return null;
  }

  return (
    <div className="progress-container">
      <div className="progress-header">
        <span className="progress-title">変化点検出実行中...</span>
        <span className="progress-stats">
          {current} / {total} 銘柄 ({percentage}%)
        </span>
      </div>
      
      <div className="progress-bar">
        <div 
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {currentStock && (
        <div className="progress-current">
          現在処理中: <strong>{currentStock}</strong>
        </div>
      )}
      
      <div className="progress-info">
        <div className="progress-item">
          <span className="progress-label">予想残り時間:</span>
          <span className="progress-value">
            {current > 0 && total > current 
              ? `約 ${Math.round(((total - current) / current) * 35)} 秒`
              : '計算中...'
            }
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;